import React from 'react'
import { GetShipperListV2Req } from '@/services/shipper/types'
import FilterList from '@/components/content/FilterList'
import ShipperSelector from '@/components/system/ShipperSelector'
import { AuthStorage } from '@/utils/storage/AuthStorage'
import { SHIPPER_TYPES } from '@/services/shipper/apis'
import { useFormContext } from 'react-hook-form'

export const INIT_FORM: GetShipperListV2Req = {
  shipperNames: [AuthStorage.user.get().SPR_NM ?? ''],
  logisticsServiceTypes: SHIPPER_TYPES,
}

interface Props {
  isLoading: boolean
  onReset: () => void
  onSearch: () => void
  onFieldChange?: (params: { fieldName: keyof GetShipperListV2Req; value: unknown; isSelectedAll?: boolean }) => void
}

function ShipperForm({ isLoading, onReset, onSearch, onFieldChange }: Props) {
  const { watch } = useFormContext<GetShipperListV2Req>()
  const values = watch()

  return (
    <FilterList
      isLoading={isLoading}
      gapRow={8}
      list={[
        [
          {
            label: '화주명',
            required: true,
            width: 500, // 두 컴포넌트를 포함할 수 있는 충분한 너비
            align: 'center',
            validationValue: values.shipperNames,
            value: <ShipperSelector<GetShipperListV2Req> onFieldChange={onFieldChange} logisticsServiceTypesWidth={120} shipperNamesWidth={250} />,
          },
        ],
      ]}
      onReset={onReset}
      onSearch={onSearch}
    />
  )
}

export default ShipperForm
